import type { UUID } from "@/core/types";

export const permissionsKeys = {
  base: ["permissions"] as const,
  updateUserPermissions: (userId: UUID) => [...permissionsKeys.base, userId, "update"] as const,
  userPermissions: (userId: UUID) => [...permissionsKeys.base, userId] as const,
} as const;
